export default {
  title: '{{company}} atualizou a sua hora de levantamento',
  title_on_site: '{{company}} atualizou a hora a que o seu pedido é servido',
  new_time_label: 'Nova hora',
};
